import { NgModule } from '@angular/core';
import { MaxPipe } from './max';
import { MinPipe } from './min';
import { PercentagePipe } from './percentage';
import { SumPipe } from './sum';
import { FloorPipe } from './floor';
import { RoundPipe } from './round';
import { SqrtPipe } from './sqrt';
import { PowerPipe } from './pow';
import { CeilPipe } from './ceil';
import { DegreesPipe } from './degrees';
import { BytesPipe } from './bytes';
import { RadiansPipe } from './radians';
export var MATH_PIPES = [
    MaxPipe, MinPipe, PercentagePipe, SumPipe, FloorPipe, RoundPipe, SqrtPipe, PowerPipe,
    CeilPipe, DegreesPipe, BytesPipe, RadiansPipe
];
var NgMathPipesModule = (function () {
    function NgMathPipesModule() {
    }
    return NgMathPipesModule;
}());
export { NgMathPipesModule };
NgMathPipesModule.decorators = [
    { type: NgModule, args: [{
                declarations: MATH_PIPES,
                imports: [],
                exports: MATH_PIPES
            },] },
];
/** @nocollapse */
NgMathPipesModule.ctorParameters = function () { return []; };
export { MaxPipe } from './max';
export { MinPipe } from './min';
export { PercentagePipe } from './percentage';
export { SumPipe } from './sum';
export { FloorPipe } from './floor';
export { RoundPipe } from './round';
export { SqrtPipe } from './sqrt';
export { PowerPipe } from './pow';
export { CeilPipe } from './ceil';
export { DegreesPipe } from './degrees';
export { BytesPipe } from './bytes';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/index.js
// module id = 238
// module chunks = 4